import { relative } from 'node:path';

import { ILogger } from '@lsk4/log';
import { getComment, jsonToFile } from '@lsk4/stringify';
import { mapSeries } from 'fishbird';
import { mkdir, unlink } from 'fs/promises';

import { log as defaultLog } from '../utils/log.js';
import { createService } from './createService.js';

type BuildOptions = {
  buildDir?: string;
  log?: ILogger;
  force?: boolean;
};

export async function build(serviceDirname: string, options: BuildOptions = {}) {
  const log = options.log || defaultLog;
  const buildDir = options.buildDir || `${serviceDirname}/build`;

  const service = await createService(serviceDirname, options);
  await unlink(`${buildDir}`).catch(() => {});
  await mkdir(buildDir, { recursive: true });
  // @ts-ignore
  const { config } = service;
  const { files = [] } = config;
  await mapSeries(files, async (fileOptions: any) => {
    const { filename, handler } = fileOptions;
    const res = await handler(fileOptions, config);
    // console.log('fileOptions', fileOptions);
    const { credType, name } = fileOptions;
    const comment = getComment({
      filename,
      values: [
        ['File type', fileOptions.type],
        ['Cred type', credType],
        ['Cred name', name],
        ['Server', service.getServiceHostname()],
        ['Project', service.getProjectPath()],
        ['Project ID', service.getProjectId()],
        ['Project Url', service.getProjectUrl()],
        ['CI/CD Setting', service.getProjectCICDSettingURL()],
      ],
      footer:
        service.getProjectCredsUrl() &&
        `
Auto generated by ${service.getProjectCredsUrl()}
If you want to change something, please contact admin repo: ${service.getProjectCredsOwner()}.
      `.trim(),
    });
    const format = fileOptions.format || fileOptions.type;
    const filepath = `${buildDir}/${filename}`;
    const { status } = await jsonToFile(filepath, res, {
      format,
      compare: !options.force,
      comment,
    });
    const relativePath = relative(process.cwd(), filepath);
    log.info(`[${status}] ${service.getProjectPath()} (${name})[${credType}] => ${relativePath}`);
  });
}
